(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["paw-bracelet-form"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('paw-bracelet-form')) {
 customElements.define('paw-bracelet-form', class extends HTMLElement {
  connectedCallback() {
   if(this.initialized)return;this.initialized=true;
   this.variants=JSON.parse(this.querySelector('[data-variants]').textContent);
   this.template=this.querySelector('[data-bracelet-template]');
   this.handleChange=e=>{if((e.type==='blur'||e.type==='change')&&e.target.matches('[data-paw] input'))e.target.value=e.target.value.trim();if(e.target.matches('[data-pack-count]'))this.querySelector('[data-bracelet-count]').value=e.target.value;this.sync();};
   this.addEventListener('change',this.handleChange);this.addEventListener('input',this.handleChange);
   this.addEventListener('blur',e=>{if(e.target.matches('[data-paw] input'))this.handleChange(e);},true);
   this.closest('form').addEventListener('invalid',e=>{e.target.closest('[data-bracelet]')?.querySelector(':scope > details')?.setAttribute('open','');e.target.closest('[data-paw]')?.querySelector(':scope > details')?.setAttribute('open','');},true);
   this.closest('form').addEventListener('submit',e=>this.submit(e));this.sync();
  }
  formatMoney(cents){return new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:this.dataset.currency||'USD'}).format(cents/100);}
  selectedVariant(total,paws){const sku=total===1?(paws<=3?'PB-SINGLE-1-3':'PB-SINGLE-4-6'):`PB-PACK-${total}`;return this.variants.find(v=>v.sku===sku);}
  makeCard(index){const holder=document.createElement('template');holder.innerHTML=this.template.innerHTML.replaceAll('__INDEX__',String(index));return holder.content.firstElementChild;}
  activeCards(){return Array.from(this.querySelectorAll('[data-bracelet]:not([hidden])'));}
  sync(){
   const total=Number(this.querySelector('[data-bracelet-count]').value),validTotal=Number.isInteger(total)&&total>=1&&total<=3;
   const container=this.querySelector('[data-bracelets]');if(validTotal)while(container.children.length<total)container.appendChild(this.makeCard(container.children.length+1));
   let available=validTotal,regularCents=0;
   container.querySelectorAll('[data-bracelet]').forEach(card=>{
    const inactive=Number(card.dataset.bracelet)>total;card.hidden=inactive;card.setAttribute('aria-hidden',String(inactive));card.querySelectorAll('input,select').forEach(input=>input.disabled=inactive);
    const count=Number(card.querySelector('[data-count]:checked')?.value),color=card.querySelector('[data-color]:checked')?.value;
    card.querySelectorAll('[data-paw]').forEach(paw=>{paw.hidden=Number(paw.dataset.paw)>count;paw.querySelectorAll('input,select').forEach(input=>input.disabled=inactive||paw.hidden);const input=paw.querySelector('input'),hasText=!!input.value.trim();input.required=!input.disabled;input.setCustomValidity(!input.disabled&&!hasText?'Please enter engraving text for this paw.':'');if(hasText||input.disabled){input.removeAttribute('aria-invalid');paw.querySelector('[data-engraving-error]').hidden=true;}paw.querySelector('[data-paw-summary]').textContent=hasText?`${input.value} · ${paw.querySelector('select').value}`:'No engraving added';paw.querySelector('[data-paw-status]').textContent=hasText?'PERSONALIZED':'REQUIRED';paw.querySelector('[data-paw-status]').dataset.complete=String(hasText);const counter=paw.querySelector('[data-character-count]');if(counter)counter.textContent=String(input.value.length);});
    const textCount=Array.from(card.querySelectorAll('[data-paw]:not([hidden]) input')).filter(i=>i.value.trim()).length;card.querySelector('[data-card-status]').textContent=textCount?`${textCount} paw${textCount===1?'':'s'} personalized`:'Engraving required';
    card.querySelector('[data-card-price]').textContent='';
    if(!inactive){available=available&&Number.isInteger(count)&&count>=1&&count<=6&&['Gold','Silver','Rose Gold'].includes(color);regularCents+=this.selectedVariant(1,count)?.price||0;}
   });
   const firstPaws=Number(container.querySelector('[data-count]:checked')?.value),variant=validTotal?this.selectedVariant(total,firstPaws):null;
   available=available&&!!variant?.available;
   const pending=this.dataset.pricePending==='true',button=this.querySelector('[data-add]');button.disabled=!available||pending||this.submitting;button.textContent=this.submitting?'Adding…':pending?'Coming soon':available?'Add to cart':'Unavailable';
   this.querySelector('[data-count-label]').textContent=`${total} bracelet${total===1?'':'s'} to customize`;
   this.querySelector('[data-selected-price]').textContent=variant?this.formatMoney(variant.price):'';
   const savings=this.querySelector('[data-pack-savings]');savings.textContent=total>1&&variant?`${this.formatMoney(variant.price/total)} per bracelet · Save ${this.formatMoney(regularCents-variant.price)} compared with buying these bracelets individually.`:'';
   this.querySelector('[data-single-prompt]').hidden=total!==1;
  }
  braceletProperties(card){
   const count=Number(card.querySelector('[data-count]:checked')?.value),color=card.querySelector('[data-color]:checked')?.value,length=card.querySelector('[data-length]'),cm=length.selectedOptions[0]?.dataset.cm;
   if(!Number.isInteger(count)||count<1||count>6||!['Gold','Silver','Rose Gold'].includes(color)||!['16','18','20'].includes(cm))throw new Error('Invalid bracelet options');
   const prefix=`Bracelet ${card.dataset.bracelet}`,machine=`_bracelet_${card.dataset.bracelet}`,properties={};
   properties[prefix]=`${color} · ${length.selectedOptions[0].textContent.trim()} · ${count} ${count===1?'paw':'paws'}`;properties[`${machine}_color`]=color;properties[`${machine}_paw_count`]=String(count);properties[`${machine}_length_cm`]=cm;properties[`${machine}_extender_cm`]='5';
   card.querySelectorAll('[data-paw]').forEach(paw=>{if(Number(paw.dataset.paw)>count)return;const input=paw.querySelector('input'),text=input.value.trim(),font=paw.querySelector('select').value;if(!text)throw new Error(`Please enter engraving text for ${prefix}, Paw ${paw.dataset.paw}.`);if(!/^F([1-9]|[1-4][0-9]|5[0-6])$/.test(font))throw new Error('Invalid font');if(input.maxLength>0&&text.length>input.maxLength)throw new Error('Engraving text is too long');properties[`${prefix} · Paw ${paw.dataset.paw}`]=`${text} · Font ${font}`;properties[`${machine}_paw_${paw.dataset.paw}_text`]=text;properties[`${machine}_paw_${paw.dataset.paw}_font`]=font;});return properties;
  }
  buildItem(){
   const total=Number(this.querySelector('[data-bracelet-count]').value),cards=this.activeCards();if(!Number.isInteger(total)||total<1||total>3||cards.length!==total)throw new Error('Invalid bracelet count');
   const count=Number(cards[0].querySelector('[data-count]:checked')?.value),variant=this.selectedVariant(total,count);if(!variant?.available)throw new Error('Unavailable pack');
   const properties={_schema:'bracelet-v2',_bracelet_count:String(total),_customization_id:this.customizationId||(this.customizationId=crypto.randomUUID())};cards.forEach(card=>Object.assign(properties,this.braceletProperties(card)));return {id:variant.id,quantity:1,properties};
  }
  async submit(event){event.preventDefault();this.sync();const button=this.querySelector('[data-add]'),form=this.closest('form');if(button.disabled)return;const error=this.querySelector('[data-error]');error.hidden=true;if(!form.reportValidity()){const invalid=Array.from(this.querySelectorAll('[data-paw] input')).filter(input=>!input.disabled&&!input.validity.valid);invalid.forEach(input=>{input.setAttribute('aria-invalid','true');input.closest('[data-paw]').querySelector('[data-engraving-error]').hidden=false;});error.textContent='Please complete the engraving text for every selected paw.';error.hidden=false;return;}this.submitting=true;this.sync();try{const item=this.buildItem();const response=await fetch(this.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[item]})});const result=await response.json();if(!response.ok||result.status)throw new Error(result.description||result.message||'Unable to add bracelets');window.location.assign(this.dataset.cartUrl);}catch(e){error.textContent=e.message;error.hidden=false;this.submitting=false;this.sync();}}
 });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["personalization-form"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('personalization-form')) {
    customElements.define(
      'personalization-form',
      class PersonalizationForm extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;
          this.initialized = true;
          this.config = JSON.parse(this.querySelector('[data-config]').textContent);
          this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
          this.sub = this.config.sub_items;
          this.perItem = !!this.config.item_count;
          // 变体和价格规则在 assets/pt-pricing.js（单元测试也用同一份，见 tests/unit）
          this.pricing = window.ptPricing.create(this.config, this.variants);
          this.subKey = String(this.sub.singular || this.sub.label).toLowerCase().replace(/[^a-z0-9]+/g, '_');
          this.propertyPrefix = `_${this.config.property_prefix || 'item'}`;
          this.messages = this.config.messages || {};
          this.template = this.querySelector('[data-item-template]');
          this.container = this.querySelector('[data-items]');
          this.countInput = this.querySelector('[data-item-count]');
          this.form = this.closest('form');
          // 返回这一页时浏览器会把上一单的单选、文字填回去，但脚本生成的卡片和照片不会恢复，两边对不上；不让浏览器保存表单值
          this.form.setAttribute('autocomplete', 'off');
          this.preselect();
          this.container.querySelectorAll('[data-skeleton]').forEach((node) => node.remove());
          this.container.removeAttribute('aria-busy');
          this.addEventListener('change', (event) => this.onChange(event));
          this.addEventListener('input', (event) => this.onChange(event));
          this.form.addEventListener('invalid', (event) => this.reveal(event.target), true);
          this.form.addEventListener('submit', (event) => this.submit(event), true);
          this.addEventListener('click', (event) => {
            const next = event.target.closest('[data-next-item]');
            if (next) this.openNext(next.closest('[data-item]'));
            if (event.target.closest('[data-sticky-add]')) this.querySelector('[data-add]').click();
            const copy = event.target.closest('[data-copy-item]');
            if (copy) this.copyItem(copy.closest('[data-item]'));
            const undo = event.target.closest('[data-copy-undo]');
            if (undo) this.undoCopy(undo.closest('[data-item]'));
            if (event.target.closest('[data-add-item]')) this.addItem();
            if (event.target.closest('[data-edit-cancel]')) this.track('edit_cancel');
            const view = event.target.closest('[data-photo-view]');
            if (view) {
              const info = this.fieldInfo(view.closest('[data-sub]').querySelector('[data-field-type="photo"]'));
              this.track('photo_view', { item: info.item, sub: info.sub });
            }
            const addSub = event.target.closest('[data-add-sub]');
            if (addSub) this.addSub(addSub.closest('[data-item]'));
            const removeSub = event.target.closest('[data-remove-sub]');
            const removeItem = event.target.closest('[data-remove-item]');
            // 删除按钮在卡片标题栏里：不让这次点击把卡片展开 / 收起
            if (removeSub || removeItem) event.preventDefault();
            if (removeSub) this.askRemove(removeSub.closest('[data-item]'), removeSub.closest('[data-sub]'));
            else if (removeItem) this.askRemove(removeItem.closest('[data-item]'), null);
          });
          // 加购成功后从购物车按返回，浏览器（尤其 iPhone）会从返回缓存原样恢复这一页：按钮卡在 "Adding…"，
          // 表单里还是刚加过的那一单。重新加载成一张新表单
          window.addEventListener('pageshow', (event) => {
            if (event.persisted && (this.leftForCart || this.submitting)) window.location.reload();
          });
          this.setupTracking();
          this.setupSticky();
          this.showFromPrice();
          this.querySelectorAll('[data-pack-price]').forEach((output) => {
            const count = Number(output.dataset.packPrice);
            const variant = this.variantFor(count, Array(count).fill(this.subMin()));
            output.textContent = variant ? this.formatMoney(variant.price).replace(/\.00$/, '') : '';
          });
          this.sync();
          this.startEdit();
        }

        // 专用编辑页（sections/pt-cart-edit.liquid，?view=edit&pt_edit=<行 key>）：读 /cart.js 里那一行，按加购属性把件数、选项、
        // 子项、照片填回表单；保存时加一行新的、再删掉旧的那行（submitEdit）。找不到那一行（已经保存过或删了，例如保存后按返回）
        // 就换成普通商品页
        async startEdit() {
          if (!this.hasAttribute('data-edit-view')) return;
          const key = new URLSearchParams(window.location.search).get('pt_edit');
          const leave = () => window.location.replace(this.dataset.productUrl);
          if (!key || this.perItem) return leave();
          this.loadingEdit = true;
          this.sync();
          let line = null;
          try {
            const cart = await (await fetch(`${this.dataset.cartUrl}.js`, { headers: { Accept: 'application/json' } })).json();
            line = (cart.items || []).find((item) => item.key === key && String(item.product_id) === this.dataset.productId) || null;
          } catch (e) {}
          this.loadingEdit = false;
          const parsed = line && this.parseLine(line);
          this.track('edit_open', { found: parsed ? 1 : 0 });
          if (!parsed) return leave();
          this.editLine = { key, count: parsed.count, variantId: line.variant_id };
          this.applyLine(parsed);
          this.sync();
        }

        // 一行加购属性 → { count, items: [{ options, custom, subCount, subs: [{ 字段: 值 }] }] }，属性名规则和 appendDefault / appendTemplated 一致
        parseLine(line) {
          const props = line.properties || {};
          const preset = this.pricing.preselect(line.sku);
          const count = Number(props[`${this.propertyPrefix}_count`] || props._item_count) || preset?.count;
          if (!this.validTotal(count)) return null;
          const items = [];
          for (let n = 1; n <= count; n += 1) {
            const entry = this.config.properties ? this.parseTemplated(props, n, count) : this.parseDefault(props, n);
            entry.subCount = entry.subCount || (n === 1 && preset?.initialSubCount) || Number(this.sub.default || this.subMin());
            items.push(entry);
          }
          return { count, items };
        }

        parseDefault(props, n) {
          const machine = `${this.propertyPrefix}_${n}`;
          const entry = { options: {}, custom: {}, subs: [] };
          // 自定义长度存的是厘米，顾客填的英寸从看得见的那条（"22.5 inches (Custom) · 1 disc"）取，取不到再从厘米换算
          const summary = String(props[`${this.config.item.label} ${n}`] || '');
          this.config.options.forEach((option) => {
            const value = props[`${machine}_${option.key}`];
            entry.options[option.key] = value;
            if (option.type !== 'select' || !value) return;
            const known = option.groups.some((group) => group.choices.some((choice) => String(choice.value) === value));
            if (known) return;
            const typed = /(?:^| · )([\d.]+) inches \(Custom\)/.exec(summary)?.[1];
            entry.custom[option.key] = typed || String(Math.round((Number(value) / 2.54) * 100) / 100);
          });
          entry.subCount = Number(props[`${machine}_${this.subKey}_count`]) || null;
          for (let m = 1; m <= (entry.subCount || this.sub.max); m += 1) {
            const values = {};
            this.sub.fields.forEach((field) => {
              values[field.key] = field.type === 'photo'
                ? props[`${this.config.item.label} ${n} · ${this.sub.label} ${m} ${field.key}`]
                : props[`${machine}_${this.subKey}_${m}_${field.key}`];
            });
            entry.subs.push(values);
          }
          return entry;
        }

        // 按 config.properties 的模板反查：值是单个占位符（"{color}"、"{photo}"）的那几条，填上件号后就是属性名
        parseTemplated(props, n, total) {
          const entry = { options: {}, custom: {}, subs: [], subCount: null };
          const resolve = (pairs, scope, into) => (pairs || []).forEach(([name, value]) => {
            const raw = /^\{([\w.]+)\}$/.exec(value);
            if (!raw) return;
            let unknown = false;
            const key = String(name).replace(/\{([\w.]+)\}/g, (_, part) => {
              if (scope[part] === undefined) unknown = true;
              return scope[part] ?? '';
            });
            if (!unknown && key in props && into[raw[1]] === undefined) into[raw[1]] = props[key];
          });
          const scope = { item: String(n), item_total: String(total) };
          resolve(this.config.properties.item, scope, entry.options);
          resolve(this.config.properties.item_after_subs, scope, entry.options);
          for (let m = 1; m <= this.sub.max; m += 1) {
            const values = {};
            resolve(this.config.properties.sub, { ...scope, sub: String(m) }, values);
            entry.subs.push(values);
          }
          return entry;
        }

        // 把解析出的内容写进表单：先按件数和每件的子项数重建卡片，再填选项、文字、字体，最后显示沿用的照片
        applyLine(parsed) {
          const radio = this.querySelector(`[data-pack-count][value="${parsed.count}"]`);
          if (radio) radio.checked = true;
          this.countInput.value = String(parsed.count);
          this.initialSubCount = null;
          this.initialSubCounts = parsed.items.map((entry) => entry.subCount);
          this.container.querySelectorAll('[data-item]').forEach((card) => card.remove());
          this.sync();
          this.initialSubCounts = null;
          const photos = [];
          const has = (select, value) => Array.from(select.options).some((option) => option.value === value);
          this.activeCards().forEach((card, k) => {
            const entry = parsed.items[k];
            // 按配置顺序填：链长的下拉框跟着前面选的款式（项链 / 手链）走
            this.config.options.forEach((option) => {
              const value = entry.options[option.key];
              if (value === undefined || value === null || value === '') return;
              if (option.type === 'select') {
                const when = option.depends_on ? entry.options[option.depends_on] : null;
                const group = (when && card.querySelector(`[data-option-group="${option.key}"][data-when="${CSS.escape(when)}"]`))
                  || card.querySelector(`[data-option-group="${option.key}"]`);
                const select = group?.querySelector('select');
                if (!select) return;
                if (has(select, value)) select.value = value;
                else if (entry.custom[option.key] && has(select, 'custom')) {
                  select.value = 'custom';
                  const input = group.querySelector('[data-custom-input]');
                  if (input) input.value = entry.custom[option.key];
                }
              } else {
                const input = card.querySelector(`[data-option="${option.key}"][value="${CSS.escape(value)}"]`);
                if (input) input.checked = true;
              }
            });
            card.querySelectorAll('[data-sub]').forEach((sub) => {
              const values = entry.subs[Number(sub.dataset.sub) - 1];
              if (!values) return;
              this.sub.fields.forEach((field) => {
                const value = values[field.key];
                if (value === undefined || value === null || value === '') return;
                if (field.type === 'swatches') {
                  const input = sub.querySelector(`[data-field="${field.key}"][value="${CSS.escape(value)}"]`);
                  if (input) input.checked = true;
                  return;
                }
                const input = sub.querySelector(`[data-field="${field.key}"]`);
                if (!input) return;
                if (field.type === 'photo') {
                  if (!String(value).includes('/uploads/')) return;
                  input.value = '';
                  input.dataset.existingUrl = value;
                  photos.push(input);
                } else if (field.type !== 'font' || has(input, value)) {
                  input.value = value;
                }
              });
            });
          });
          this.sync();
          this.reusingPhoto = true;
          photos.forEach((input) => this.updatePhoto(input));
          this.reusingPhoto = false;
          this.sync();
        }

        // 照片：顾客这次选的文件，或者编辑购物车里那一件时沿用的已上传地址（字符串）
        photoOf(input) {
          return input.files?.[0] || input.dataset.existingUrl || null;
        }

        // 已上传的照片按原图存，预览向 CDN 要缩小的版本（同购物车）
        sizedUpload(url, width) {
          return `${url}${url.includes('?') ? '&' : '?'}width=${width}`;
        }

        // 链接带 ?variant= 时，选中该变体 SKU 对应的件数和子项数量（例如 PP-SINGLE-2 → 1 件、2 个头像），规则见 pt-pricing.js
        preselect() {
          const id = new URLSearchParams(window.location.search).get('variant');
          const sku = id && this.variants.find((variant) => String(variant.id) === id)?.sku;
          const chosen = this.pricing.preselect(sku);
          if (!chosen) return;
          const radio = this.querySelector(`[data-pack-count][value="${chosen.count}"]`);
          if (radio) radio.checked = true;
          this.countInput.value = String(chosen.count);
          this.initialSubCount = chosen.initialSubCount;
          this.initialSubCounts = chosen.initialSubCounts;
        }

        formatMoney(cents) {
          return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: this.dataset.currency || 'USD' }).format(cents / 100);
        }

        plural(count, singular, plural) {
          return `${count} ${count === 1 ? singular : plural}`;
        }

        subMin() {
          return this.pricing.subMin();
        }

        subMax(total) {
          return this.pricing.subMax(total);
        }

        // Hides sub-count choices above the set's limit and moves a too-high choice down to it.
        limitSubCount(card, total) {
          const max = this.subMax(total);
          const radios = Array.from(card.querySelectorAll('input[type="radio"][data-sub-count]'));
          if (!radios.length) return;
          radios.forEach((radio) => {
            const over = Number(radio.value) > max;
            radio.hidden = over;
            const label = card.querySelector(`label[for="${radio.id}"]`);
            if (label) label.hidden = over;
          });
          const checked = radios.find((radio) => radio.checked);
          if (!checked || Number(checked.value) > max) {
            const fallback = radios.find((radio) => Number(radio.value) === max);
            if (fallback) fallback.checked = true;
          }
          const fieldset = radios[0].closest('fieldset');
          if (fieldset) fieldset.hidden = max <= this.subMin();
        }

        pack(count) {
          return this.pricing.pack(count);
        }

        variantFor(count, subCounts) {
          return this.pricing.variantFor(count, subCounts);
        }

        itemVariant(subCount) {
          return this.pricing.itemVariant(subCount);
        }

        itemCount() {
          const value = Number.parseInt(this.countInput.value, 10);
          if (!this.perItem) return value;
          const min = Number(this.config.item_count.min || 1);
          const max = Number(this.config.item_count.max);
          return Number.isFinite(value) ? Math.min(Math.max(value, min), max) : min;
        }

        validTotal(total) {
          return this.pricing.validTotal(total);
        }

        activeCards() {
          return Array.from(this.container.querySelectorAll('[data-item]:not([hidden])'));
        }

        makeCard(index) {
          const holder = document.createElement('template');
          holder.innerHTML = this.template.innerHTML.replaceAll('__INDEX__', String(index));
          const card = holder.content.firstElementChild;
          if (index > 1) card.querySelector(':scope > details')?.removeAttribute('open');
          const initial = this.initialSubCounts?.[index - 1] ?? (index === 1 ? this.initialSubCount : null);
          if (initial) {
            const radio = card.querySelector(`[data-sub-count][value="${initial}"]`);
            if (radio) radio.checked = true;
          }
          card.dataset.customizationId = `${this.config.customization_id_prefix || ''}${crypto.randomUUID()}`;
          return card;
        }

        onChange(event) {
          const target = event.target;
          const edited = event.isTrusted && target.closest('[data-item]');
          if (edited?.copyUndo) edited.copyUndo = null;
          if (target.matches('[data-pack-count]')) this.countInput.value = target.value;
          // 选照片时浏览器会先后发 input 和 change，只在 change 时处理，否则预览和 photo_pick / photo_check 埋点各跑两遍
          if (event.type === 'change' && target.matches('[data-field-type="photo"]')) this.updatePhoto(target);
          // 开头的空格不占字数（结尾的空格在失焦和提交时去掉）
          if (event.type === 'input' && target.matches('[data-field-type="text"]') && /^\s/.test(target.value)) target.value = target.value.replace(/^\s+/, '');
          if (event.type === 'change' && target.matches('[data-field-type="text"]')) target.value = target.value.trim();
          this.sync();
          this.trackFields();
        }

        // 文字没变就不写：sync() 在输入框失焦时也会跑，重写按钮/标签里的文字节点会让 Chrome 吞掉紧接着的那次点击
        setText(el, text) {
          if (el && el.textContent !== text) el.textContent = text;
        }

        updatePhoto(input) {
          const sub = input.closest('[data-sub]');
          const image = sub.querySelector('[data-photo-image]');
          const placeholder = sub.querySelector('[data-photo-preview] > svg');
          const file = input.files?.[0];
          // 选了新照片，就不再沿用购物车里那张；取消选择（没有文件）时原来那张还在
          if (file) delete input.dataset.existingUrl;
          const existing = file ? '' : input.dataset.existingUrl || '';
          const filled = !!(file || existing);
          if (image.dataset.objectUrl) URL.revokeObjectURL(image.dataset.objectUrl);
          delete image.dataset.objectUrl;
          if (file) {
            image.dataset.objectUrl = URL.createObjectURL(file);
            image.src = image.dataset.objectUrl;
          } else if (existing) {
            image.src = this.sizedUpload(existing, 400);
          } else {
            image.removeAttribute('src');
          }
          image.hidden = !filled;
          // 占位图标是 svg，没有 .hidden 属性，要直接改 hidden 属性
          placeholder.toggleAttribute('hidden', filled);
          // 点缩略图看大图：交给 pt-image-preview 的 data-pt-preview
          const view = sub.querySelector('[data-photo-view]');
          if (view) {
            view.hidden = !filled;
            if (filled) view.dataset.ptPreview = file ? image.dataset.objectUrl : this.sizedUpload(existing, 1600);
            else delete view.dataset.ptPreview;
          }
          // 有照片后标题改成 "Photo added"，不显示文件名（手机上常是 inbound5767… 这种看不懂的名字）
          const cta = sub.querySelector('[data-photo-cta]');
          if (cta) cta.textContent = filled ? 'Photo added' : cta.dataset.empty;
          const name = sub.querySelector('[data-photo-name]');
          if (name) {
            name.textContent = file ? file.name : name.dataset.empty;
            name.hidden = filled;
          }
          const button = sub.querySelector('[data-photo-button]');
          if (button) button.textContent = filled ? button.dataset.filled : button.dataset.empty;
          input.closest('.pet-personalization__upload')?.toggleAttribute('data-filled', filled);
          this.checkPhoto(sub, file);
          // 整件复制带过来的照片记在 item_copy 里，不算一次新选的照片
          if (file && !this.reusingPhoto) this.trackPhoto(input, sub, file);
        }

        // 校验错误的显示，同 antd 表单：出错的框（文字框或整张上传卡片）变红框，框下面一行红字说明；改对了马上消失
        errorHost(input) {
          return input.closest('[data-upload-card]') || input.closest('.field') || input;
        }

        fieldErrorText(input) {
          if (input.dataset.fieldType === 'photo') return 'Upload a photo of this pet.';
          if (input.matches('[data-custom-input]')) {
            // 填了但比最短的自定义长度还短时，直接说最少多少
            return input.value && input.validity.rangeUnderflow ? `Enter ${input.min} inches or more.` : 'Enter a length in inches.';
          }
          const label = input.closest('.field')?.querySelector('.field__label')?.textContent.trim();
          return label ? `Enter the ${label.toLowerCase()}.` : 'This field is required.';
        }

        showFieldError(input) {
          const host = this.errorHost(input);
          host.classList.add('pz-invalid');
          input.setAttribute('aria-invalid', 'true');
          let message = host.nextElementSibling?.matches('[data-field-error]') ? host.nextElementSibling : null;
          if (!message) {
            message = document.createElement('p');
            message.className = 'form__message pz-field-error';
            message.dataset.fieldError = '';
            message.id = `${input.id}-error`;
            message.innerHTML = this.querySelector('[data-error-icon]')?.innerHTML || '';
            message.append(document.createElement('span'));
            host.after(message);
          }
          message.querySelector('span').textContent = this.fieldErrorText(input);
          input.setAttribute('aria-describedby', message.id);
        }

        clearFieldError(input) {
          const host = this.errorHost(input);
          host.classList.remove('pz-invalid');
          input.removeAttribute('aria-invalid');
          input.removeAttribute('aria-describedby');
          if (host.nextElementSibling?.matches('[data-field-error]')) host.nextElementSibling.remove();
        }

        // 每次 sync 后：已经改对、或者被藏起来 / 禁用的框，去掉错误
        refreshErrors() {
          this.querySelectorAll('[aria-invalid="true"]').forEach((input) => {
            // 改对了就去掉；还不对就按现在的值更新说明（例如自定义长度从"没填"变成"太短"）
            if (input.disabled || !input.required || input.checkValidity()) this.clearFieldError(input);
            else this.showFieldError(input);
          });
          // 漏填引起的总提示：所有框都改对以后一起收起
          if (this.validationShown && !this.querySelector('[aria-invalid="true"]')) {
            this.validationShown = false;
            const error = this.querySelector('[data-error]');
            if (error) error.hidden = true;
          }
        }

        // 子项在本件里的名称，只有这一件不止一个子项时才带上，例如 "Necklace 1" / "Piece 1 · Portrait 2"
        slotLabel(card, sub, visibleSubs) {
          const item = `${this.config.item.label} ${card.dataset.item}`;
          return visibleSubs > 1 ? `${item} · ${this.sub.label} ${sub.dataset.sub}` : item;
        }

        // 这一件里顾客填过的内容（照片或文字）；选项（颜色、长度）不算
        hasContent(card) {
          return Array.from(card.querySelectorAll('[data-sub]:not([hidden]) [data-field]'))
            .some((input) => (input.type === 'file' ? !!this.photoOf(input) : input.dataset.fieldType === 'text' && !!input.value.trim()));
        }

        // 一件的全部状态，按页面顺序：选项、子项数量、自定义长度，以及每个子项的照片、文字、字体、颜色。
        // 每件卡片出自同一个模板，元素顺序一致，所以按位置一一对应（第 1 片对第 1 片）
        cardState(card) {
          const read = (el) => (el.type === 'radio' ? el.checked : el.type === 'file' ? this.photoOf(el) : el.value);
          return {
            options: Array.from(card.querySelectorAll('[data-option], [data-sub-count], [data-custom-input]'), read),
            fields: Array.from(card.querySelectorAll('[data-sub] [data-field]'), read),
          };
        }

        setCardState(card, state) {
          const write = (el, value) => {
            if (el.type === 'radio') el.checked = !!value;
            else el.value = value ?? '';
          };
          card.querySelectorAll('[data-option], [data-sub-count], [data-custom-input]').forEach((el, k) => write(el, state.options[k]));
          // 先按新的子项数量显示 / 启用子项，再填内容
          this.sync();
          const photos = [];
          card.querySelectorAll('[data-sub] [data-field]').forEach((el, k) => {
            const value = state.fields[k];
            if (el.type !== 'file') return write(el, value);
            if (this.photoOf(el) === value) return;
            delete el.dataset.existingUrl;
            // 照片用 DataTransfer 放进文件框，之后预览、校验、上传都和自己选的一样；老浏览器不支持时照片留空。
            // 编辑购物车时沿用的照片是已上传的地址（字符串），直接带过去
            if (typeof value === 'string') {
              el.value = '';
              el.dataset.existingUrl = value;
            } else if (value && this.canTransfer) {
              const transfer = new DataTransfer();
              transfer.items.add(value);
              el.files = transfer.files;
            } else {
              el.value = '';
            }
            photos.push(el);
          });
          this.reusingPhoto = true;
          photos.forEach((el) => this.updatePhoto(el));
          this.reusingPhoto = false;
          this.sync();
          this.trackFields();
        }

        // 第 2 件起顶部的"整件复制"：来源是前面最近一件填过内容的；这一件还空着时才显示
        updateCopy() {
          if (this.canTransfer === undefined) {
            try { this.canTransfer = typeof new DataTransfer().items?.add === 'function'; } catch (e) { this.canTransfer = false; }
          }
          const cards = this.activeCards();
          const hasPhoto = this.sub.fields.some((field) => field.type === 'photo');
          cards.forEach((card, k) => {
            const row = card.querySelector('[data-copy-row]');
            const done = card.querySelector('[data-copy-done]');
            if (!row || !done) return;
            const source = cards.slice(0, k).reverse().find((other) => this.hasContent(other));
            const show = !!source && card.dataset.added !== 'true' && !this.submitting && !card.copyUndo && !this.hasContent(card);
            row.hidden = !show;
            row.copySource = show ? source : null;
            if (show) {
              this.setText(row.querySelector('[data-copy-label]'), `Copy everything from ${this.config.item.label} ${source.dataset.item}`);
              this.setText(row.querySelector('[data-copy-note]'), !hasPhoto
                ? 'Same text and options. You can still change anything.'
                : this.canTransfer ? 'Same photo, text and options. You can still change anything.' : 'Same text and options. Add the photo again.');
            }
            const undo = card.copyUndo;
            done.hidden = !undo || card.dataset.added === 'true' || !!this.submitting;
            if (undo) {
              const from = undo.source?.isConnected && !undo.source.hidden ? ` from ${this.config.item.label} ${undo.source.dataset.item}` : '';
              // 复制带过来的子项数量会改价格（例如 3 个头像多 $20），写明新的总价
              const total = undo.total ? ` Your total is now ${undo.total}.` : '';
              this.setText(done.querySelector('[data-copy-done-text]'), `Copied${from}.${total}`);
            }
          });
        }

        copyItem(card) {
          const source = card?.querySelector('[data-copy-row]')?.copySource;
          if (!source || this.submitting) return;
          const before = this.cardState(card);
          const price = this.querySelector('[data-selected-price]');
          const oldTotal = price?.textContent;
          this.setCardState(card, this.cardState(source));
          card.copyUndo = { state: before, source, total: price && price.textContent !== oldTotal ? price.textContent : '' };
          this.track('item_copy', { item: Number(card.dataset.item), from: Number(source.dataset.item) });
          this.sync();
          card.querySelector('[data-copy-undo]')?.focus({ preventScroll: true });
        }

        undoCopy(card) {
          const undo = card?.copyUndo;
          if (!undo || this.submitting) return;
          card.copyUndo = null;
          this.setCardState(card, undo.state);
          this.track('item_copy_undo', { item: Number(card.dataset.item) });
          card.querySelector('[data-copy-item]')?.focus({ preventScroll: true });
        }

        // 删一件：套装降一档（3 → 2 → 1，只剩 1 件时不能删）；删一个子项：这一件的子项数减一（不低于最少数量）。
        // 后面的件或子项往前挪、重新编号，已填的内容（含照片）跟着走。填过内容的先弹确认框。
        askRemove(card, sub) {
          const target = sub || card;
          const hasContent = Array.from(target.querySelectorAll('[data-field]'))
            .some((input) => (input.type === 'file' ? !!this.photoOf(input) : input.dataset.fieldType === 'text' && !!input.value.trim()));
          if (!hasContent) return this.removeTarget(card, sub);
          const modal = document.getElementById(`PzRemoveModal-${this.dataset.productId}`);
          if (!modal?.show) return this.removeTarget(card, sub);
          const item = this.config.item;
          const total = this.itemCount();
          let title;
          let text;
          if (sub) {
            const { subCount } = this.cardOptions(card);
            title = `Remove ${this.sub.label} ${sub.dataset.sub}?`;
            text = `Its photo and text will be cleared. ${item.label} ${card.dataset.item} will have ${this.plural(subCount - 1, this.sub.singular, this.sub.plural)}.`;
          } else {
            const rest = this.activeCards().filter((other) => other !== card).map((other) => this.cardOptions(other).subCount);
            const variant = this.perItem ? null : this.variantFor(total - 1, rest);
            title = `Remove ${item.label} ${card.dataset.item}?`;
            text = `Its photo and engraving will be cleared. Your order changes to ${this.plural(total - 1, item.singular, item.plural)}${variant ? ` (${this.formatMoney(variant.price)})` : ''}.`;
          }
          modal.querySelector('[data-remove-title]').textContent = title;
          modal.querySelector('[data-remove-text]').textContent = text;
          // 按钮写出结果（Keep / Remove + 名称），不用"是 / 否"
          const name = sub ? `${this.sub.label} ${sub.dataset.sub}` : `${item.label} ${card.dataset.item}`;
          modal.querySelector('[data-remove-keep]').textContent = `Keep ${name}`;
          modal.querySelector('[data-remove-confirm]').textContent = `Remove ${name}`;
          this.pendingRemove = { card, sub };
          if (!modal.dataset.pzBound) {
            modal.dataset.pzBound = 'true';
            modal.addEventListener('click', (event) => {
              if (event.target.closest('[data-remove-keep]')) modal.hide();
              if (event.target.closest('[data-remove-confirm]')) {
                const pending = this.pendingRemove;
                modal.hide();
                if (pending) this.removeTarget(pending.card, pending.sub);
              }
            });
            // 弹窗打开时主题会隐藏页面滚动条，电脑上内容会左右跳一下：打开前补上滚动条宽度，关闭时（各种关法都会发 modalClosed）去掉
            document.body.addEventListener('modalClosed', () => { document.body.style.paddingRight = ''; });
          }
          const scrollbar = window.innerWidth - document.documentElement.clientWidth;
          if (scrollbar > 0) document.body.style.paddingRight = `${scrollbar}px`;
          modal.show(sub?.querySelector('[data-remove-sub]') || card.querySelector('[data-remove-item]'));
        }

        // 加一件：套装升一档（1 → 2 → 3，到最大就不显示按钮）；加一个子项：这一件的子项数加一（到上限为止）。
        // 新加的一定是空白的：之前用件数 / 数量按钮减少时藏起来的旧内容不带回来
        addItem() {
          const total = this.itemCount();
          const next = total + 1;
          if (this.submitting || !this.canAddItem(total)) return;
          this.container.querySelectorAll('[data-item]').forEach((card) => {
            if (Number(card.dataset.item) > total) card.remove();
          });
          this.countInput.value = String(next);
          const radio = this.querySelector(`[data-pack-count][value="${next}"]`);
          if (radio) radio.checked = true;
          this.track('item_add', { item: next });
          this.sync();
          const card = this.container.querySelector(`[data-item="${next}"]`);
          card?.querySelector(':scope > details')?.setAttribute('open', '');
          this.scrollToTop(card);
        }

        canAddItem(total) {
          if (this.perItem) return total + 1 <= Number(this.config.item_count.max) && !this.container.querySelector('[data-item][data-added="true"]');
          return this.validTotal(total + 1);
        }

        addSub(card) {
          if (this.submitting || !card) return;
          const { subCount } = this.cardOptions(card);
          if (subCount >= this.subMax(this.itemCount())) return;
          const number = subCount + 1;
          const old = card.querySelector(`[data-sub="${number}"]`);
          const radio = card.querySelector(`[data-sub-count][value="${number}"]`);
          if (!old || !radio) return;
          old.querySelectorAll('[data-photo-image]').forEach((image) => image.dataset.objectUrl && URL.revokeObjectURL(image.dataset.objectUrl));
          const fresh = this.makeCard(Number(card.dataset.item)).querySelector(`[data-sub="${number}"]`);
          old.replaceWith(fresh);
          radio.checked = true;
          this.track('sub_add', { item: Number(card.dataset.item), sub: number });
          this.sync();
          fresh.querySelector(':scope > details')?.setAttribute('open', '');
          this.scrollToTop(fresh);
        }

        removeTarget(card, sub) {
          this.pendingRemove = null;
          if (!card?.isConnected) return;
          (sub || card).querySelectorAll('[data-photo-image]').forEach((image) => image.dataset.objectUrl && URL.revokeObjectURL(image.dataset.objectUrl));
          if (sub) this.removeSub(card, sub);
          else this.removeItem(card);
        }

        removeItem(card) {
          const total = this.itemCount();
          if (total <= 1 || card.dataset.added === 'true' || !this.validTotal(total - 1)) return;
          const number = Number(card.dataset.item);
          card.remove();
          Array.from(this.container.querySelectorAll('[data-item]')).forEach((other, k) => this.renumberItem(other, k + 1));
          this.countInput.value = String(total - 1);
          const radio = this.querySelector(`[data-pack-count][value="${total - 1}"]`);
          if (radio) radio.checked = true;
          this.track('item_remove', { item: number });
          this.sync();
          const shown = this.container.querySelector(`[data-item="${Math.min(number, total - 1)}"]`);
          shown?.querySelector(':scope > details')?.setAttribute('open', '');
          this.scrollToTop(shown);
        }

        removeSub(card, sub) {
          const { subCount } = this.cardOptions(card);
          if (subCount <= this.subMin()) return;
          const number = Number(sub.dataset.sub);
          const list = sub.parentElement;
          // 末尾补一个空白子项，保持每件都有 1…max 个子项块
          const fresh = this.makeCard(Number(card.dataset.item)).querySelector(`[data-sub="${this.sub.max}"]`);
          fresh.querySelector(':scope > details')?.removeAttribute('open');
          // 先给新块临时编号，免得它的单选和同编号的旧块同名，把旧块的选中状态挤掉
          this.renumberSub(fresh, 'new');
          sub.remove();
          list.append(fresh);
          Array.from(list.querySelectorAll(':scope > [data-sub]')).forEach((other, k) => this.renumberSub(other, k + 1));
          const radio = card.querySelector(`[data-sub-count][value="${subCount - 1}"]`);
          if (radio) radio.checked = true;
          this.track('sub_remove', { item: Number(card.dataset.item), sub: number });
          this.sync();
          card.querySelector(`[data-sub="${Math.min(number, subCount - 1)}"] > details`)?.setAttribute('open', '');
        }

        // 卡片里的 id / for / name 都带件号（PzField2-1-photo-…、PzSubCount2…），挪位置后按新件号改写
        renumberItem(card, number) {
          card.dataset.item = String(number);
          card.querySelectorAll('[id], [for], [name]').forEach((el) => {
            ['id', 'for', 'name'].forEach((attr) => {
              const value = el.getAttribute(attr);
              if (value) el.setAttribute(attr, value.replace(/^(Pz(?:Custom|Field|Option|Select|SubCount))\d+(?=-|$)/, `$1${number}`));
            });
          });
          this.setText(card.querySelector('.pet-personalization__number'), String(number));
          this.setText(card.querySelector('.pet-personalization__necklace-title strong'), `${this.config.item.label} ${number}`);
        }

        renumberSub(sub, number) {
          sub.dataset.sub = String(number);
          sub.querySelectorAll('[id], [for], [name]').forEach((el) => {
            ['id', 'for', 'name'].forEach((attr) => {
              const value = el.getAttribute(attr);
              if (value) el.setAttribute(attr, value.replace(/^(PzField\d+-)[^-]+(?=-)/, `$1${number}`));
            });
          });
          this.setText(sub.querySelector('.pet-personalization__disc-number'), String(number));
          this.setText(sub.querySelector('.pet-personalization__disc-title strong'), `${this.sub.label} ${number}`);
        }

        // 照片太小时提示（不拦截），定制首饰的售后问题多半出在照片上
        checkPhoto(sub, file) {
          const warning = sub.querySelector('[data-photo-warning]');
          if (!warning) return;
          warning.hidden = true;
          if (!file || !sub.querySelector('[data-photo-image]').dataset.objectUrl) return;
          const probe = new Image();
          probe.onload = () => {
            const short = Math.min(probe.naturalWidth, probe.naturalHeight);
            if (short && short < 800) {
              warning.textContent = `This photo is quite small (${probe.naturalWidth}×${probe.naturalHeight}). A larger, sharper photo gives a cleaner engraving.`;
              warning.hidden = false;
            }
          };
          probe.src = sub.querySelector('[data-photo-image]').dataset.objectUrl;
        }

        // 对照表（字体表、耳朵表）是一张规则网格图：按序号裁出对应格子做预览。
        // 默认按列排（字体表 F1–F10 在第一列），grid.order 为 'row' 时按行排。
        paintChart(preview, grid, index, label) {
          const columns = grid.columns_x.length;
          const column = grid.order === 'row' ? index % columns : Math.floor(index / grid.rows);
          const row = grid.order === 'row' ? Math.floor(index / columns) : index % grid.rows;
          const set = (name, value) => preview.style.setProperty(name, String(value));
          set('--pz-iw', grid.image[0]);
          set('--pz-ih', grid.image[1]);
          set('--pz-x', grid.columns_x[column]);
          set('--pz-y', grid.y0 + row * grid.row_height);
          set('--pz-cw', grid.cell_width[column]);
          set('--pz-ch', grid.row_height);
          // 预览是按钮（点了打开整张对照表），读屏时同时说出当前选的是哪个、点了会做什么
          preview.setAttribute('aria-label', preview.tagName === 'BUTTON' ? `${label}. Open the full chart` : label);
        }

        // 字体：下拉框下面是所选字体放大的样字（从字体表裁出），跟着选择变
        updateFontPreview(select) {
          const box = select.closest('[data-font-field]');
          if (!box) return;
          const preview = box.querySelector('[data-font-preview]');
          const field = this.sub.fields.find((entry) => entry.key === select.dataset.field);
          if (!preview || !field?.chart_grid) return;
          this.paintChart(preview, field.chart_grid, Number(select.value.slice(1)) - 1, `Font ${select.value} sample`);
        }

        // 带对照表的下拉项（例如狗耳朵）：按所选项在列表里的位置裁出对应格子
        updateOptionPreviews(card) {
          this.config.options.forEach((option) => {
            if (option.type !== 'select' || !option.chart_grid) return;
            const preview = card.querySelector(`[data-option-preview="${option.key}"]`);
            const select = card.querySelector(`select[data-option="${option.key}"]`);
            if (!preview || !select || select.selectedIndex < 0) return;
            this.paintChart(preview, option.chart_grid, select.selectedIndex, select.selectedOptions[0].textContent.trim());
          });
        }

        // 把一件或一个子项的顶部滚到固定页头下面。上面的卡片刚收起、这一张刚展开，要等排版完成再算位置；
        // 滚动期间关掉浏览器的滚动锚定，否则它会为了"保持眼前内容不动"把位置再挪一次，落点就不准了
        scrollToTop(el) {
          if (!el) return;
          const page = document.documentElement;
          requestAnimationFrame(() => {
            const header = document.querySelector('.section-header');
            const sticky = header && /sticky|fixed/.test(getComputedStyle(header).position);
            const offset = (sticky ? header.getBoundingClientRect().height : 0) + 12;
            const top = Math.max(0, el.getBoundingClientRect().top + window.scrollY - offset);
            page.style.overflowAnchor = 'none';
            window.scrollTo({ top, behavior: 'smooth' });
            clearTimeout(this.anchorTimer);
            this.anchorTimer = setTimeout(() => { page.style.overflowAnchor = ''; }, 1000);
          });
        }

        openNext(card) {
          const next = card.nextElementSibling;
          if (!next || next.hidden) return;
          card.querySelector(':scope > details')?.removeAttribute('open');
          next.querySelector(':scope > details')?.setAttribute('open', '');
          this.scrollToTop(next);
        }

        showFromPrice() {
          const output = this.querySelector('[data-from-price]');
          const cents = this.pricing.fromPrice();
          output.textContent = cents === null ? '' : `From ${this.formatMoney(cents)}`;
          output.hidden = cents === null;
        }

        // 手机上：表单在视野里、但原加购按钮看不到时，底部出现总价 + 加购栏
        setupSticky() {
          const bar = this.querySelector('[data-sticky]');
          const add = this.querySelector('[data-add]');
          if (!bar || !('IntersectionObserver' in window)) return;
          let formVisible = false;
          let buttonVisible = false;
          const update = () => {
            const show = formVisible && !buttonVisible;
            bar.classList.toggle('is-visible', show);
            bar.setAttribute('aria-hidden', String(!show));
          };
          new IntersectionObserver(([entry]) => { formVisible = entry.isIntersecting; update(); }).observe(this.querySelector('.pet-personalization__panel'));
          new IntersectionObserver(([entry]) => { buttonVisible = entry.isIntersecting; update(); }).observe(add);
        }

        // 记下"已经加购并去了购物车"，返回这一页时 pageshow 据此重新加载
        goToCart() {
          this.leftForCart = true;
          window.location.assign(this.dataset.cartUrl);
        }

        reveal(target) {
          target.closest('[data-item]')?.querySelector(':scope > details')?.setAttribute('open', '');
          target.closest('[data-sub]')?.querySelector(':scope > details')?.setAttribute('open', '');
        }

        // Reads the chosen values of one item, in config order.
        cardOptions(card) {
          const values = {};
          const options = this.config.options.map((option) => {
            let value;
            let label;
            let custom = false;
            if (option.type === 'select') {
              const group = card.querySelector(`[data-option-group="${option.key}"][data-when="${values[option.depends_on]}"]`)
                || card.querySelector(`[data-option-group="${option.key}"]`);
              const selected = group?.querySelector('select')?.selectedOptions[0];
              value = selected?.value;
              label = selected?.textContent.trim();
              if (value === 'custom') {
                custom = true;
                const inches = Number(group.querySelector('[data-custom-input]')?.value);
                value = Number.isFinite(inches) && inches > 0 ? String(Math.round(inches * 2.54 * 100) / 100) : '';
                label = `${inches} inches (Custom)`;
              }
            } else {
              value = card.querySelector(`[data-option="${option.key}"]:checked`)?.value;
              label = value;
            }
            values[option.key] = value;
            return { option, value, label, custom };
          });
          const subCount = Number(card.querySelector('[data-sub-count]:checked')?.value ?? card.querySelector('[data-sub-count]')?.value);
          return { options, values, subCount };
        }

        fieldValue(sub, field) {
          if (field.type === 'swatches') return sub.querySelector(`[data-field="${field.key}"]:checked`)?.value || '';
          const input = sub.querySelector(`[data-field="${field.key}"]`);
          if (field.type === 'photo') return input ? this.photoOf(input) : null;
          return input?.value?.trim() || '';
        }

        sync() {
          const total = this.itemCount();
          if (this.perItem && String(total) !== this.countInput.value) this.countInput.value = String(total);
          const validTotal = this.validTotal(total);
          if (validTotal) {
            while (this.container.children.length < total) this.container.appendChild(this.makeCard(this.container.children.length + 1));
          }
          let available = validTotal;
          let regularCents = 0;
          let itemsCents = 0;
          const subCounts = [];
          const addedAny = !!this.container.querySelector('[data-item][data-added="true"]');
          if (this.perItem) this.countInput.disabled = addedAny || !!this.submitting;
          this.container.querySelectorAll('[data-item]').forEach((card) => {
            const inactive = Number(card.dataset.item) > total;
            const added = card.dataset.added === 'true';
            card.hidden = inactive;
            card.setAttribute('aria-hidden', String(inactive));
            this.limitSubCount(card, total);
            const { values, subCount } = this.cardOptions(card);
            const locked = inactive || added;
            card.querySelectorAll('[data-option], [data-sub-count]').forEach((input) => (input.disabled = locked));
            card.querySelectorAll('[data-option-group]').forEach((group) => {
              const option = this.config.options.find((entry) => entry.key === group.dataset.optionGroup);
              group.hidden = !!option.depends_on && group.dataset.when !== values[option.depends_on];
              const select = group.querySelector('select');
              select.disabled = locked || group.hidden;
              const customField = group.querySelector('[data-custom-field]');
              if (customField) {
                const on = !group.hidden && select.value === 'custom';
                customField.hidden = !on;
                const input = customField.querySelector('[data-custom-input]');
                input.disabled = locked || !on;
                input.required = on && !locked;
              }
            });
            card.querySelectorAll('[data-sub-price]').forEach((output) => {
              const variant = this.itemVariant(Number(output.dataset.subPrice));
              this.setText(output, variant ? this.formatMoney(variant.price).replace(/\.00$/, '') : '');
            });
            let complete = 0;
            let cardRequired = false;
            let cardFilled = false;
            let photoMissing = false;
            const subRadio = card.querySelector('input[type="radio"][data-sub-count]');
            const subChoice = !!subRadio && !subRadio.closest('fieldset')?.hidden;
            card.querySelectorAll('[data-sub]').forEach((sub) => {
              sub.hidden = Number(sub.dataset.sub) > subCount;
              sub.setAttribute('aria-hidden', String(sub.hidden));
              const off = locked || sub.hidden;
              let missing = 0;
              let photoAdded = false;
              let filledAny = false;
              sub.querySelectorAll('[data-field]').forEach((input) => {
                input.disabled = off;
                const type = input.dataset.fieldType;
                if (type === 'choice' || type === 'font') return;
                const required = input.hasAttribute('data-required') && !off;
                const filled = type === 'photo' ? !!this.photoOf(input) : !!input.value.trim();
                // 沿用购物车里已上传的照片时文件框是空的：不能再标 required，否则浏览器会判它漏填
                input.required = required && !(type === 'photo' && filled && !input.files?.[0]);
                input.setCustomValidity(required && !filled ? `Please complete ${this.sub.label} ${sub.dataset.sub}.` : '');
                if (required && !filled) missing += 1;
                if (required) cardRequired = true;
                if (filled) filledAny = true;
                if (filled && !sub.hidden) cardFilled = true;
                if (type === 'photo' && filled) photoAdded = true;
                const counter = input.closest('.pet-personalization__field-with-count')?.querySelector('[data-character-count]');
                this.setText(counter, String(input.value.length));
              });
              const status = sub.querySelector('[data-sub-status]');
              const hasPhoto = !!sub.querySelector('[data-field-type="photo"]');
              const labels = this.sub.status || {};
              // 没有必填项、也什么都没填（比如可选刻字留空）时显示 empty 文案，不显示“已完成”
              const empty = !missing && !filledAny;
              // 状态只是提示，不是按钮：缺照片写 "Photo needed"（不写 "Add photo"，录屏里有人把它当按钮点）
              this.setText(status, missing
                ? (hasPhoto && !photoAdded ? 'Photo needed' : labels.missing || 'Required')
                : empty ? (labels.empty === 'Add photo' ? 'Photo needed' : labels.empty || 'Optional') : labels.done || (hasPhoto ? 'Photo added' : 'Done'));
              status.dataset.complete = String(!missing && !empty);
              status.dataset.state = missing ? 'missing' : empty ? 'empty' : 'done';
              if (!sub.hidden && !missing) complete += 1;
              if (!sub.hidden && missing && hasPhoto && !photoAdded) photoMissing = true;
              // 这一件只有一个子项时不编号（"Disc" 而不是 "1 Disc 1"）
              const single = subCount === 1;
              const subNumber = sub.querySelector('.pet-personalization__disc-number');
              if (subNumber) subNumber.hidden = single;
              this.setText(sub.querySelector('.pet-personalization__disc-title strong'), single ? this.sub.label : `${this.sub.label} ${sub.dataset.sub}`);
              const removeSub = sub.querySelector('[data-remove-sub]');
              if (removeSub) {
                removeSub.hidden = off || !subChoice || subCount <= this.subMin();
                const name = `Remove ${this.sub.label} ${sub.dataset.sub}`;
                if (removeSub.getAttribute('aria-label') !== name) { removeSub.setAttribute('aria-label', name); removeSub.title = name; }
              }
            });
            // 没有必填项、顾客也还没填字时不写 Done，免得像是已经替顾客弄好了
            const cardStatus = card.querySelector('[data-card-status]');
            this.setText(cardStatus, added
              ? 'Added to cart'
              : complete === subCount ? (!cardRequired && !cardFilled ? 'Engraving optional' : 'Done')
              : subCount === 1 ? (photoMissing ? 'Photo needed' : 'Not finished')
              : `${complete} of ${this.plural(subCount, this.sub.singular, this.sub.plural)} complete`);
            // 只有一件、一个子项时，件的标题写 "Your necklace"、不编号，也不写 "0 of 1 disc complete"（子项旁已有状态）
            const onlyOne = total === 1;
            cardStatus.hidden = onlyOne && subCount === 1 && !added;
            const itemNumber = card.querySelector('.pet-personalization__number');
            if (itemNumber) itemNumber.hidden = onlyOne;
            this.setText(card.querySelector('.pet-personalization__necklace-title strong'), onlyOne ? `Your ${this.config.item.singular}` : `${this.config.item.label} ${card.dataset.item}`);
            card.querySelectorAll('[data-field-type="font"]').forEach((select) => this.updateFontPreview(select));
            this.updateOptionPreviews(card);
            const nextButton = card.querySelector('[data-next-item]');
            if (nextButton) {
              const nextNumber = Number(card.dataset.item) + 1;
              nextButton.hidden = inactive || nextNumber > total;
              // 按钮是 flex 容器，文字和数字分开会吞掉中间的空格，所以整句一起写
              this.setText(nextButton.querySelector('[data-next-label]'), `Continue to ${this.config.item.label} ${nextNumber}`);
            }
            const removeItem = card.querySelector('[data-remove-item]');
            if (removeItem) {
              removeItem.hidden = inactive || added || total <= 1 || !this.validTotal(total - 1);
              const name = `Remove ${this.config.item.label} ${card.dataset.item}`;
              if (removeItem.getAttribute('aria-label') !== name) { removeItem.setAttribute('aria-label', name); removeItem.title = name; }
            }
            const single = this.itemVariant(subCount);
            this.setText(card.querySelector('[data-card-price]'), (this.perItem || total === 1) && single ? this.formatMoney(single.price) : '');
            if (!inactive) {
              subCounts.push(subCount);
              available = available && Number.isInteger(subCount) && subCount >= this.subMin() && subCount <= this.subMax(total) && !!single && (!this.perItem || single.available);
              regularCents += single?.price || 0;
              itemsCents += single?.price || 0;
            }
          });
          const variant = this.perItem ? null : validTotal ? this.variantFor(total, subCounts) : null;
          if (!this.perItem) available = available && !!variant?.available;
          // 加一个子项 / 加一件：按钮只写动作，价格变化写在旁边或下一行；到上限时按钮换成一句说明
          this.activeCards().forEach((card, k) => {
            const row = card.querySelector('[data-add-sub-row]');
            const limit = card.querySelector('[data-add-sub-limit]');
            if (!row) return;
            const radio = card.querySelector('input[type="radio"][data-sub-count]');
            const subCount = subCounts[k];
            const choice = card.dataset.added !== 'true' && !this.submitting && !!radio && !radio.closest('fieldset')?.hidden;
            const max = this.subMax(total);
            const can = choice && subCount < max;
            row.hidden = !can;
            if (limit) {
              limit.hidden = !choice || can;
              this.setText(limit, `Up to ${this.plural(max, this.sub.singular, this.sub.plural)} per ${this.config.item.singular}.`);
            }
            if (!can) return;
            let delta = 0;
            if (this.perItem || total === 1) {
              const now = this.itemVariant(subCount);
              const more = this.itemVariant(subCount + 1);
              if (now && more) delta = more.price - now.price;
            } else if (variant) {
              const more = this.variantFor(total, subCounts.map((n, j) => (j === k ? n + 1 : n)));
              if (more) delta = more.price - variant.price;
            }
            this.setText(row.querySelector('[data-add-note]'), delta > 0 ? `+${this.formatMoney(delta)}` : '');
          });
          const addRow = this.querySelector('[data-add-item-row]');
          const addLimit = this.querySelector('[data-add-item-limit]');
          if (addRow) {
            const can = validTotal && !this.submitting && this.canAddItem(total);
            addRow.hidden = !can;
            if (addLimit) {
              const most = this.perItem
                ? Number(this.config.item_count.max)
                : Math.max(...(this.config.packs?.options || []).map((pack) => Number(pack.count)));
              addLimit.hidden = can || !validTotal || this.submitting || total < most || most <= 1;
              this.setText(addLimit, `${this.perItem ? 'Orders' : 'Sets'} go up to ${this.plural(most, this.config.item.singular, this.config.item.plural)}.`);
            }
            if (can) {
              let note = '';
              if (this.perItem) {
                const single = this.itemVariant(this.subMin());
                if (single) note = `+${this.formatMoney(single.price)}`;
              } else {
                // 套装可能限制每件的子项数（例如 2 条装每条只有 1 片），按加一件之后的上限算价格
                const cap = this.subMax(total + 1);
                const counts = [...subCounts, Number(this.sub.default || this.subMin())].map((n) => Math.min(n, cap));
                const bigger = this.variantFor(total + 1, counts);
                if (bigger) note = `${this.plural(total + 1, this.config.item.singular, this.config.item.plural)} for ${this.formatMoney(bigger.price)} · ${this.formatMoney(bigger.price / (total + 1))} each`;
              }
              this.setText(addRow.querySelector('[data-add-note]'), note);
            }
          }
          const pending = this.dataset.pricePending === 'true';
          const button = this.querySelector('[data-add]');
          const failed = this.perItem && this.failedOnce;
          const item = this.config.item;
          // 多件时写明件数，免得顾客以为填完一件就已经加进购物车
          const multi = validTotal && total > 1;
          const editing = !!this.editLine || this.hasAttribute('data-edit-view');
          button.disabled = !available || pending || !!this.submitting || !!this.loadingEdit;
          // 上传和加购进行中锁住整张表单（选项、照片、字体表链接、底部栏），免得中途改了内容或打开弹窗后被跳去购物车；
          // 编辑时读购物车那一下也锁住，免得顾客先填的内容被购物车里的覆盖
          this.toggleAttribute('inert', !!this.submitting || !!this.loadingEdit);
          const totalCents = this.perItem ? itemsCents : variant ? variant.price : null;
          // 按钮直接带最终价（免运费、不收销售税、关税店铺付），顾客不用为了看总价去点加购；整数价不写 .00
          const priced = (label) => (available && totalCents !== null ? `${label} · ${this.formatMoney(totalCents).replace(/\.00$/, '')}` : label);
          const action = editing ? 'Save changes' : multi ? `Add ${this.plural(total, item.singular, item.plural)} to cart` : 'Add to cart';
          this.setText(button, this.submitting
            ? (editing ? 'Saving…' : this.messages.adding || 'Adding…')
            : pending ? 'Coming soon' : !available ? 'Unavailable' : failed ? this.messages.retry || 'Retry'
            : priced(action));
          const cartNote = this.querySelector('[data-cart-note]');
          this.setText(cartNote, multi ? `${total === 2 ? `Both ${item.plural}` : `All ${total} ${item.plural}`} go into your cart together.` : '');
          cartNote.hidden = !multi || editing;
          const sticky = this.querySelector('[data-sticky-add]');
          if (sticky) {
            sticky.disabled = button.disabled;
            // 底部栏是整行按钮，和上面的按钮同一句话；件数后面的商品名去掉，360px 手机上也是一行
            this.setText(sticky, button.textContent.replace(/^Add (\d+) .+ to cart/, 'Add $1 to cart'));
          }
          this.querySelector('[data-count-label]').textContent = `${this.plural(total, item.singular, item.plural)} to customize`;
          this.querySelector('[data-selected-price]').textContent = totalCents === null ? '' : this.formatMoney(totalCents);
          const savings = this.querySelector('[data-pack-savings]');
          savings.textContent = !this.perItem && total > 1 && variant && regularCents > variant.price
            ? `${this.formatMoney(variant.price / total)} per ${item.singular} · You save ${this.formatMoney(regularCents - variant.price)} vs. buying separately`
            : '';
          const prompt = this.querySelector('[data-single-prompt]');
          const bigger = (this.config.packs?.options || []).filter((pack) => Number(pack.count) > 1).sort((a, b) => a.count - b.count)[0];
          const biggerVariant = bigger && this.variantFor(Number(bigger.count), Array(Number(bigger.count)).fill(this.subMin()));
          prompt.hidden = this.perItem || total !== 1 || !biggerVariant || !this.config.packs.single_prompt;
          prompt.textContent = !prompt.hidden
            ? this.config.packs.single_prompt.replace('{each}', this.formatMoney(biggerVariant.price / Number(bigger.count)))
            : '';
          // 只有一件时不套卡片（标题栏藏起来，内容直接平铺），所以这一件必须是展开的
          this.classList.toggle('pz-single', validTotal && total === 1);
          if (validTotal && total === 1) this.container.querySelector('[data-item="1"] > details')?.setAttribute('open', '');
          this.updateCopy();
          this.refreshErrors();
        }

        // Validates one item and returns its values; throws on anything outside the config.
        readItem(card) {
          const read = this.cardOptions(card);
          read.options.forEach(({ option, value, custom }) => {
            if (custom) {
              const group = card.querySelector(`[data-option-group="${option.key}"]:not([hidden])`);
              const choice = option.groups.find((entry) => entry.when === group?.dataset.when) || option.groups[0];
              const inches = Number(group?.querySelector('[data-custom-input]')?.value);
              if (!value || !choice?.custom || !(inches >= Number(choice.custom.min || 0))) throw new Error('Invalid custom length');
              return;
            }
            const allowed = option.type === 'select'
              ? option.groups.flatMap((group) => group.choices.map((choice) => String(choice.value)))
              : option.values;
            if (!allowed.includes(value)) throw new Error('Invalid item options');
          });
          if (!Number.isInteger(read.subCount) || read.subCount < this.subMin() || read.subCount > this.subMax(this.itemCount())) throw new Error('Invalid item options');
          read.subs = [];
          card.querySelectorAll('[data-sub]').forEach((sub) => {
            const m = Number(sub.dataset.sub);
            if (m > read.subCount) return;
            const values = {};
            const hasText = this.sub.fields.some((field) => field.type === 'text' && this.fieldValue(sub, field));
            this.sub.fields.forEach((field) => {
              const value = this.fieldValue(sub, field);
              if (field.type === 'photo') {
                if (!value && field.required) throw new Error(`Please upload a photo for ${this.config.item.label} ${card.dataset.item}, ${this.sub.label} ${m}.`);
              } else if (field.type === 'text') {
                const input = sub.querySelector(`[data-field="${field.key}"]`);
                if (!value && field.required) throw new Error(`Please complete ${this.config.item.label} ${card.dataset.item}, ${this.sub.label} ${m}.`);
                if (input.maxLength > 0 && value.length > input.maxLength) throw new Error('Engraving text is too long');
              } else if (field.type === 'swatches') {
                if (!field.values.includes(value)) throw new Error('Invalid item options');
              } else if (field.type === 'font') {
                const max = Number(field.count);
                if (!/^F\d{1,3}$/.test(value) || Number(value.slice(1)) > max) throw new Error('Invalid font');
                values[field.key] = hasText ? value : '';
                return;
              }
              values[field.key] = value;
            });
            read.subs.push({ m, values });
          });
          return read;
        }

        // Default naming: visible summaries + _<prefix>_N_* hidden fields.
        appendDefault(add, addFile, card, read) {
          const number = card.dataset.item;
          const prefix = `${this.config.item.label} ${number}`;
          const machine = `${this.propertyPrefix}_${number}`;
          add(prefix, [...read.options.map((entry) => entry.label), this.plural(read.subCount, this.sub.singular, this.sub.plural)].join(' · '));
          read.options.forEach(({ option, value }) => add(`${machine}_${option.key}`, value));
          (this.config.fixed || []).forEach((entry) => add(`${machine}_${entry.key}`, String(entry.value)));
          add(`${machine}_${this.subKey}_count`, String(read.subCount));
          read.subs.forEach(({ m, values }) => {
            const subPrefix = `${prefix} · ${this.sub.label} ${m}`;
            const subMachine = `${machine}_${this.subKey}_${m}`;
            const template = this.sub.summary_template;
            const summary = {};
            this.sub.fields.forEach((field) => {
              const value = values[field.key];
              if (!value) return;
              // 沿用的照片是已上传的地址，原样作为属性值（和上传后 Shopify 存的值一样）
              if (field.type === 'photo') return value instanceof File ? addFile(`${subPrefix} ${field.key}`, value) : add(`${subPrefix} ${field.key}`, value);
              add(`${subMachine}_${field.key}`, value);
              if (template) summary[field.key] = value;
              else add(`${subPrefix} ${field.key}`, value);
            });
            if (template && Object.keys(summary).length) {
              // 模板按 " · " 分段，某段的占位符全是空值就整段省掉（例如可选的名字或背面刻字没填）
              const text = template.split(' · ')
                .filter((part) => !/\{\w+\}/.test(part) || [...part.matchAll(/\{(\w+)\}/g)].some(([, key]) => summary[key]))
                .map((part) => part.replace(/\{(\w+)\}/g, (_, key) => summary[key] ?? ''))
                .join(' · ');
              add(subPrefix, text);
            } else if (template && this.sub.empty_summary) {
              // 子项什么都没填（比如可选刻字留空）也在购物车里列出来，顾客能看到每一个子项
              add(subPrefix, this.sub.empty_summary);
            }
          });
        }

        // Template naming from config.properties (keeps property names a factory slip already reads).
        appendTemplated(add, addFile, card, read, total) {
          const context = { item: card.dataset.item, item_total: String(total), sub_count: String(read.subCount) };
          read.options.forEach(({ option, value, label }) => {
            context[option.key] = value;
            context[`${option.key}.label`] = label;
          });
          (this.config.fixed || []).forEach((entry) => (context[entry.key] = String(entry.value)));
          read.subs.forEach(({ m, values }) => Object.entries(values).forEach(([key, value]) => (context[`sub_${m}.${key}`] = value)));
          const fill = (text, scope) => String(text).replace(/\{([\w.]+)\}/g, (_, key) => {
            const value = scope[key];
            return value instanceof File ? '' : value ?? '';
          });
          const emit = (pairs, scope) => (pairs || []).forEach(([name, value]) => {
            const key = fill(name, scope);
            const raw = /^\{(\w+)\}$/.exec(value);
            if (raw && scope[raw[1]] instanceof File) return addFile(key, scope[raw[1]]);
            const text = fill(value, scope);
            if (text !== '') add(key, text);
          });
          const properties = this.config.properties;
          emit(properties.item, context);
          read.subs.forEach(({ m, values }) => emit(properties.sub, { ...context, ...values, sub: String(m) }));
          emit(properties.item_after_subs, context);
        }

        buildLine(card, read, variant, total) {
          const data = new FormData();
          const add = (name, value) => data.append(`properties[${name}]`, value);
          const addFile = (name, file) => data.append(`properties[${name}]`, file, file.name);
          data.append('id', String(variant.id));
          data.append('quantity', '1');
          if (this.config.properties) {
            add('_customization_id', card.dataset.customizationId);
            this.appendTemplated(add, addFile, card, read, total);
          } else {
            this.appendDefault(add, addFile, card, read);
          }
          this.appendDelivery(add);
          return data;
        }

        appendDelivery(add) {
          if (this.dataset.deliveryPropertyName && this.dataset.deliveryPropertyValue) add(this.dataset.deliveryPropertyName, this.dataset.deliveryPropertyValue);
        }

        // Pack mode: one FormData for the whole set.
        buildFormData() {
          const total = this.itemCount();
          const cards = this.activeCards();
          if (!this.validTotal(total) || cards.length !== total) throw new Error('Invalid item count');
          const reads = cards.map((card) => this.readItem(card));
          if (this.perItem) {
            return cards.map((card, k) => {
              const variant = this.itemVariant(reads[k].subCount);
              if (!variant?.available) throw new Error('This option is unavailable.');
              return this.buildLine(card, reads[k], variant, total);
            });
          }
          const variant = this.variantFor(total, reads.map((entry) => entry.subCount));
          if (!variant?.available) throw new Error('This set is unavailable.');
          const data = new FormData();
          const add = (name, value) => data.append(`properties[${name}]`, value);
          const addFile = (name, file) => data.append(`properties[${name}]`, file, file.name);
          data.append('id', String(variant.id));
          data.append('quantity', '1');
          if (this.config.properties) {
            add('_customization_id', this.customizationId || (this.customizationId = `${this.config.customization_id_prefix || ''}${crypto.randomUUID()}`));
            cards.forEach((card, k) => this.appendTemplated(add, addFile, card, reads[k], total));
          } else {
            add('_schema', this.config.schema);
            add(`${this.propertyPrefix}_count`, String(total));
            add('_customization_id', this.customizationId || (this.customizationId = `${this.config.customization_id_prefix || ''}${crypto.randomUUID()}`));
            cards.forEach((card, k) => this.appendDefault(add, addFile, card, reads[k]));
          }
          this.appendDelivery(add);
          return data;
        }

        // 埋点：只记步骤、字段 key、件数和文件大小档，不记照片、文件名和刻字内容
        track(name, data = {}) {
          try {
            window.ptTrack?.(`form_${name}`, { product: this.dataset.productHandle, item_count: this.itemCount(), ...data });
          } catch (e) {}
        }

        sizeBand(bytes) {
          const mb = bytes / 1048576;
          return mb < 1 ? '<1' : mb < 3 ? '1-3' : mb < 6 ? '3-6' : mb < 10 ? '6-10' : '>10';
        }

        fieldInfo(input) {
          if (!input) return { field: 'unknown' };
          const custom = input.matches('[data-custom-input]');
          return {
            field: input.dataset.field || (custom ? 'custom_length' : input.tagName.toLowerCase()),
            ftype: input.dataset.fieldType || (custom ? 'custom' : ''),
            item: Number(input.closest('[data-item]')?.dataset.item || 0),
            sub: Number(input.closest('[data-sub]')?.dataset.sub || 0),
          };
        }

        setupTracking() {
          this.tracking = { done: new Set(), touched: false, added: false, posted: false, left: false, start: Date.now() };
          // 填到一半离开（切走、关页面）时记一次进行到哪一步
          document.addEventListener('visibilitychange', () => {
            if (document.visibilityState !== 'hidden' || this.tracking.added || !this.tracking.touched || this.tracking.left) return;
            this.tracking.left = true;
            const required = this.form.querySelectorAll('[required]').length;
            const missing = this.form.querySelectorAll(':invalid').length;
            this.track('leave', {
              done: Math.max(required - missing, 0),
              required,
              photos: [...this.querySelectorAll('[data-field-type="photo"]')].filter((input) => this.photoOf(input)).length,
              sec: Math.round((Date.now() - this.tracking.start) / 1000),
            });
          });
        }

        // 每个必填项在每件、每个子项上第一次填完时记一次（sync() 已经按当前件数设好了 required）
        trackFields() {
          if (!this.tracking) return;
          this.tracking.touched = true;
          this.form.querySelectorAll('[required]').forEach((input) => {
            const filled = input.type === 'file' ? !!input.files?.[0] : !!String(input.value).trim();
            if (!filled) return;
            const info = this.fieldInfo(input);
            const key = `${info.item}-${info.sub}-${info.field}`;
            if (this.tracking.done.has(key)) return;
            this.tracking.done.add(key);
            this.track('field_done', info);
          });
        }

        trackPhoto(input, sub, file) {
          const info = this.fieldInfo(input);
          const type = (file.type.split('/')[1] || 'other').replace('jpg', 'jpeg');
          this.track('photo_pick', { item: info.item, sub: info.sub, ftype: ['jpeg', 'png', 'webp'].includes(type) ? type : 'other', mb: this.sizeBand(file.size) });
          const url = sub.querySelector('[data-photo-image]')?.dataset.objectUrl;
          if (!url) return;
          const probe = new Image();
          probe.onload = () => {
            const short = Math.min(probe.naturalWidth, probe.naturalHeight);
            this.track('photo_check', { item: info.item, sub: info.sub, ok: 1, short: short < 800 ? '<800' : short <= 1500 ? '800-1500' : '>1500' });
          };
          probe.onerror = () => this.track('photo_check', { item: info.item, sub: info.sub, ok: 0 });
          probe.src = url;
        }

        // edit：购物车里改一件时的保存，结果记成 form_edit_save，不算进加购的 add_send / add_result
        async post(body, edit = false) {
          // 照片在这一步随加购请求一起上传，所以记上传张数、总大小档和耗时
          const photos = [...body.values()].filter((value) => value instanceof File);
          const sent = { photos: photos.length, mb_total: this.sizeBand(photos.reduce((sum, file) => sum + file.size, 0)) };
          const started = Date.now();
          const done = edit ? 'edit_save' : 'add_result';
          if (edit) Object.assign(sent, { from: this.editLine.count, how: 'replace' });
          if (this.tracking) this.tracking.posted = true;
          if (!edit) this.track('add_send', sent);
          let response;
          try {
            response = await fetch(this.dataset.addUrl, {
              method: 'POST',
              headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
              body,
            });
          } catch (e) {
            this.track(done, { ...sent, ok: 0, status: 0, reason: 'network', ms: Date.now() - started });
            throw e;
          }
          const result = await response.json().catch(() => ({}));
          const ok = response.ok && !result.status;
          // 编辑的保存要等旧行删掉才记（submitEdit 里记 replaced），这里只在失败时记
          if (!edit || !ok) this.track(done, { ...sent, ok: ok ? 1 : 0, status: response.status, reason: ok ? '' : response.status === 413 ? 'too_large' : 'shopify', ms: Date.now() - started });
          if (!ok) throw new Error(result.description || result.message || 'Unable to add to cart');
          return { sent, ms: Date.now() - started };
        }

        // 保存编辑，属性都和正常加购一模一样（_customization_id 是新的），按情况选副作用最少的做法：
        // - 件数（变体）没变、也没换新照片：用 /cart/change.js 按行 key 原地换掉这一行的属性（updateLine）。
        //   不算一次"加入购物车"（Shopify 统计和 Meta 像素不会多记），这一行在购物车里的位置也不变。
        // - 改了件数或换了新照片：变体没法原地改，新照片只能随加购上传，所以先按正常加购加一行，再按行 key 删掉旧行。
        //   先加后删：加失败时购物车原样不动；删失败时重试一次，再不行就带着两行去购物车
        async submitEdit(error) {
          this.submitting = true;
          this.sync();
          if (this.tracking) this.tracking.posted = false;
          const fail = (message) => {
            error.textContent = message;
            error.hidden = false;
            this.submitting = false;
            this.sync();
          };
          let body;
          try {
            body = this.buildFormData();
          } catch (e) {
            this.track('edit_save', { ok: 0, status: 0, reason: 'client' });
            return fail(e.message);
          }
          const sameVariant = String(body.get('id')) === String(this.editLine.variantId);
          const newPhotos = [...body.values()].some((value) => value instanceof File);
          if (sameVariant && !newPhotos) return this.updateLine(body, fail);
          let posted;
          try {
            posted = await this.post(body, true);
          } catch (e) {
            return fail(e.message);
          }
          let replaced = 0;
          for (let attempt = 0; attempt < 2 && !replaced; attempt += 1) {
            try {
              const response = await fetch(this.dataset.changeUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ id: this.editLine.key, quantity: 0 }),
              });
              if (response.ok) replaced = 1;
            } catch (e) {}
          }
          this.track('edit_save', { ...posted.sent, ok: 1, status: 200, replaced, ms: posted.ms });
          if (this.tracking) this.tracking.added = true;
          this.goToCart();
        }

        // 原地更新：把加购时会发的属性原样写给 /cart/change.js（照片是已上传的地址字符串）
        async updateLine(body, fail) {
          const properties = {};
          for (const [name, value] of body.entries()) {
            const match = /^properties\[(.*)\]$/.exec(name);
            if (match) properties[match[1]] = value;
          }
          const started = Date.now();
          if (this.tracking) this.tracking.posted = true;
          let response = null;
          try {
            response = await fetch(this.dataset.changeUrl, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: this.editLine.key, quantity: 1, properties }),
            });
          } catch (e) {}
          const ok = !!response?.ok;
          this.track('edit_save', {
            photos: 0, from: this.editLine.count, how: 'update', ok: ok ? 1 : 0, replaced: ok ? 1 : 0,
            status: response?.status || 0, reason: ok ? '' : response ? 'shopify' : 'network', ms: Date.now() - started,
          });
          if (!ok) {
            const result = response ? await response.json().catch(() => ({})) : {};
            return fail(result.description || result.message || 'Your changes could not be saved. Please try again.');
          }
          if (this.tracking) this.tracking.added = true;
          this.goToCart();
        }

        // 加购时漏填的总提示：写明缺什么（照片、名字、长度），多件时写明是第几件
        missingMessage(first, card, copyable) {
          const where = card && this.itemCount() > 1 ? ` for ${this.config.item.label} ${card.dataset.item}` : '';
          let what = 'Fill in the missing details';
          if (first?.dataset.fieldType === 'photo') what = 'Add a pet photo';
          else if (first?.matches('[data-custom-input]')) what = 'Enter your custom length';
          else {
            const label = first?.closest('.field')?.querySelector('.field__label')?.textContent.trim();
            if (label) what = `Enter the ${label.toLowerCase()}`;
          }
          const copy = copyable ? ` Same pet? Use “Copy everything from ${this.config.item.label} ${copyable.dataset.item}” at the top.` : '';
          return `${what}${where} to continue.${copy}`;
        }

        async submit(event) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.sync();
          const button = this.querySelector('[data-add]');
          if (button.disabled) return;
          const error = this.querySelector('[data-error]');
          error.hidden = true;
          if (!this.form.checkValidity()) {
            const invalid = Array.from(this.form.querySelectorAll(':invalid')).filter((input) => this.contains(input) && !input.matches('fieldset'));
            const first = invalid[0] || this.form.querySelector(':invalid');
            this.track('add_invalid', { ...this.fieldInfo(first), missing: invalid.length });
            // 同 antd 表单：每个没填好的框变红框，框下面一行红字说明（不用浏览器自带的气泡）
            invalid.forEach((input) => {
              this.reveal(input);
              this.showFieldError(input);
            });
            this.validationShown = true;
            const card = first?.closest('[data-item]');
            // 再展开并滚到屏幕中间：浏览器自己滚的话会把输入框停在顶部，手机上被固定页头挡住
            if (first) {
              this.reveal(first);
              (first.closest('.pet-personalization__upload') || first).scrollIntoView({ block: 'center' });
            }
            // 这一件还空着、前面有填过的件时，提示可以用顶部的整件复制
            const copyRow = card?.querySelector('[data-copy-row]');
            const copyable = copyRow && !copyRow.hidden && copyRow.copySource;
            error.textContent = this.missingMessage(first, card, copyable);
            error.hidden = false;
            return;
          }
          if (this.perItem) return this.submitPerItem(error);
          if (this.editLine) return this.submitEdit(error);
          this.submitting = true;
          this.sync();
          if (this.tracking) this.tracking.posted = false;
          try {
            await this.post(this.buildFormData());
            if (this.tracking) this.tracking.added = true;
            this.goToCart();
          } catch (e) {
            if (this.tracking && !this.tracking.posted) this.track('add_result', { ok: 0, status: 0, reason: 'client' });
            error.textContent = e.message;
            error.hidden = false;
            this.submitting = false;
            this.sync();
          }
        }

        // Per-item mode: one cart line per item, added in order; failed items can be retried.
        async submitPerItem(error) {
          const total = this.itemCount();
          const cards = this.activeCards();
          let lines;
          try {
            lines = this.buildFormData();
          } catch (e) {
            this.track('add_result', { ok: 0, status: 0, reason: 'client' });
            error.textContent = e.message;
            error.hidden = false;
            return;
          }
          const pending = cards.map((card, k) => [card, lines[k]]).filter(([card]) => card.dataset.added !== 'true');
          if (!pending.length) return this.goToCart();
          this.submitting = true;
          this.sync();
          const failures = [];
          for (const [card, body] of pending) {
            try {
              await this.post(body);
              card.dataset.added = 'true';
            } catch (e) {
              failures.push({ index: card.dataset.item, message: e.message });
            }
          }
          this.submitting = false;
          if (!failures.length) {
            if (this.tracking) this.tracking.added = true;
            return this.goToCart();
          }
          this.failedOnce = true;
          const added = cards.filter((card) => card.dataset.added === 'true').length;
          const template = this.messages.partial_error || '{added} added. {failed} could not be added. Review and retry.';
          const details = [...new Set(failures.map((failure) => failure.message).filter(Boolean))].join(' ');
          error.textContent = `${template.replace('{added}', String(added)).replace('{failed}', failures.map((failure) => failure.index).join(', '))} ${details}`.trim();
          error.hidden = false;
          this.sync();
        }
      }
    );
  }

  // The theme's product photo viewer (only still used for videos / 3D models; photos open pt-image-preview) and the
  // remove confirmation: the phone's Back button would leave the product page. Here Back closes the pop-up
  // instead; a tap outside the picture also closes the photo viewer.
  if (!window.ptChartModals) {
    window.ptChartModals = true;
    const modalSelector = 'product-modal, modal-dialog.pz-confirm-modal';
    const initChartModals = () => {
      document.querySelectorAll(modalSelector).forEach((modal) => {
        if (modal.dataset.ptChartInit) return;
        modal.dataset.ptChartInit = 'true';
        if (!modal.matches('.pz-confirm-modal')) {
          modal.addEventListener('click', (event) => {
            if (modal.hasAttribute('open') && !event.target.closest('img, button, video, iframe, deferred-media, product-model')) modal.hide();
          });
        }
        new MutationObserver(() => {
          if (modal.hasAttribute('open')) {
            if (!(history.state && history.state.ptChart === modal.id)) history.pushState({ ptChart: modal.id }, '');
          } else if (history.state && history.state.ptChart === modal.id) {
            history.back();
          }
        }).observe(modal, { attributes: true, attributeFilter: ['open'] });
      });
    };
    window.addEventListener('popstate', () => {
      const open = [...document.querySelectorAll(modalSelector)].find((modal) => modal.hasAttribute('open'));
      if (open) open.hide();
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initChartModals);
    else initChartModals();
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pet-personalization-form"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pet-personalization')) {
    customElements.define(
      'pet-personalization',
      class PetPersonalization extends HTMLElement {
        connectedCallback() {
          this.form = this.closest('form[action*="/cart/add"]') || this.closest('form');
          this.countInput = this.querySelector('[data-necklace-count]');
          this.countLabel = this.querySelector('[data-necklace-count-label]');
          this.totalOutput = this.querySelector('[data-order-total]');
          this.list = this.querySelector('[data-necklace-list]');
          this.template = this.querySelector('[data-necklace-template]');
          this.errorOutput = this.querySelector('[data-form-error]');
          this.submitButton = this.form?.querySelector('[name="add"]');
          this.submitLabel = this.submitButton?.querySelector('span');
          this.originalSubmitLabel = this.submitLabel?.textContent?.trim() || '';
          this.addedIndexes = new Set();
          this.busy = false;
          this.handleCountChange = () => this.syncNecklaces();
          this.handleFormChange = (event) => this.handleFieldChange(event.target);
          this.handleInvalid = (event) => this.revealInvalidField(event.target);
          this.handleSubmit = (event) => this.submitPersonalizations(event);
          this.countInput?.addEventListener('input', this.handleCountChange);
          this.countInput?.addEventListener('change', this.handleCountChange);
          this.addEventListener('change', this.handleFormChange);
          this.addEventListener('input', this.handleFormChange);
          this.form?.addEventListener('invalid', this.handleInvalid, true);
          this.form?.addEventListener('submit', this.handleSubmit, true);
          this.syncNecklaces();
        }

        disconnectedCallback() {
          this.countInput?.removeEventListener('input', this.handleCountChange);
          this.countInput?.removeEventListener('change', this.handleCountChange);
          this.removeEventListener('change', this.handleFormChange);
          this.removeEventListener('input', this.handleFormChange);
          this.form?.removeEventListener('invalid', this.handleInvalid, true);
          this.form?.removeEventListener('submit', this.handleSubmit, true);
          this.querySelectorAll('[data-photo-image]').forEach((image) => {
            if (image.dataset.objectUrl) URL.revokeObjectURL(image.dataset.objectUrl);
          });
        }

        requestedCount() {
          const parsed = Number.parseInt(this.countInput?.value || '1', 10);
          const maximum = Number.parseInt(this.countInput?.max || '10', 10);
          return Number.isFinite(parsed) && parsed > 0 ? Math.min(parsed, maximum) : 1;
        }

        activeCards() {
          return Array.from(this.list?.querySelectorAll('[data-necklace]:not([hidden])') || []);
        }

        createCard(index) {
          const holder = document.createElement('template');
          holder.innerHTML = this.template.innerHTML.replaceAll('__INDEX__', String(index));
          const card = holder.content.firstElementChild;
          if (card) {
            const randomPart = globalThis.crypto?.randomUUID?.()
              || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
            card.dataset.customizationId = `pet-${randomPart}`;
          }
          return card;
        }

        syncNecklaces() {
          if (!this.list || !this.template || this.busy) return;
          const count = this.requestedCount();
          if (this.countInput && this.countInput.value !== String(count)) this.countInput.value = String(count);
          for (let index = this.list.children.length + 1; index <= count; index += 1) {
            const card = this.createCard(index);
            if (card) this.list.append(card);
          }
          Array.from(this.list.children).forEach((card, cardIndex) => {
            const active = cardIndex < count;
            card.hidden = !active;
            card.setAttribute('aria-hidden', String(!active));
            card.querySelectorAll('input, select').forEach((input) => {
              if (!active) input.disabled = true;
            });
            if (active) this.updateCard(card);
          });
          if (this.countLabel) {
            const labelTemplate = count === 1 ? this.dataset.countLabelSingular : this.dataset.countLabel;
            this.countLabel.textContent = labelTemplate.replace('__COUNT__', String(count));
          }
          this.updateTotal();
        }

        handleFieldChange(target) {
          if (!(target instanceof HTMLInputElement || target instanceof HTMLSelectElement)) return;
          const card = target.closest('[data-necklace]');
          if (!card || card.dataset.added === 'true') return;
          if (target.matches('[data-photo-input]')) this.updatePhoto(target);
          if (target.matches('[data-name-input], [data-back-text]')) {
            const counter = target.closest('.pet-personalization__field-with-count')?.querySelector('[data-character-count]');
            if (counter) counter.textContent = String(target.value.length);
          }
          this.updateCard(card);
          this.updateTotal();
        }

        updatePhoto(input) {
          const disc = input.closest('[data-disc]');
          const status = disc?.querySelector('[data-photo-status]');
          const image = disc?.querySelector('[data-photo-image]');
          const placeholder = disc?.querySelector('[data-photo-preview] svg');
          const file = input.files?.[0];
          if (status) {
            status.textContent = file ? status.dataset.readyLabel : status.dataset.emptyLabel;
            status.dataset.complete = String(Boolean(file));
          }
          if (!image || !placeholder) return;
          if (image.dataset.objectUrl) URL.revokeObjectURL(image.dataset.objectUrl);
          if (file) {
            const objectUrl = URL.createObjectURL(file);
            image.src = objectUrl;
            image.dataset.objectUrl = objectUrl;
            image.hidden = false;
            placeholder.hidden = true;
          } else {
            image.removeAttribute('src');
            image.hidden = true;
            placeholder.hidden = false;
          }
        }

        updateCard(card) {
          const lengthSelect = card.querySelector('[data-chain-length]');
          const customLength = card.querySelector('[data-custom-length]');
          const customField = card.querySelector('[data-custom-length-field]');
          const isCustom = lengthSelect?.value === 'custom';
          if (customField) customField.hidden = !isCustom;
          if (lengthSelect) lengthSelect.disabled = card.dataset.added === 'true';
          if (customLength) {
            customLength.disabled = !isCustom || card.dataset.added === 'true';
            customLength.required = isCustom && card.dataset.added !== 'true';
          }
          const selectedVariant = card.querySelector('[data-disc-count]:checked');
          const count = Number.parseInt(selectedVariant?.value || '1', 10);
          const added = card.dataset.added === 'true';
          card.querySelectorAll('[data-disc]').forEach((disc) => {
            const active = Number(disc.dataset.disc) <= count;
            disc.hidden = !active;
            disc.setAttribute('aria-hidden', String(!active));
            disc.querySelectorAll('input, select').forEach((input) => {
              input.disabled = !active || added;
            });
            const photo = disc.querySelector('[data-photo-input]');
            if (photo) photo.required = active && !added;
          });
          card.querySelectorAll('[data-disc-count]').forEach((input) => {
            input.disabled = added || input.dataset.available === 'false';
          });
          const priceOutput = card.querySelector('[data-necklace-price]');
          if (priceOutput) priceOutput.textContent = this.formatMoney(Number(selectedVariant?.dataset.price || 0));
          const complete = (!isCustom || Boolean(customLength?.value && customLength.checkValidity())) && Array.from(card.querySelectorAll('[data-disc]:not([hidden]) [data-photo-input]')).every((input) => Boolean(input.files?.[0]));
          const status = card.querySelector('[data-necklace-status]');
          if (status) status.textContent = added ? this.dataset.addedLabel : complete ? this.dataset.readyLabel : this.dataset.incompleteLabel;
        }

        updateTotal() {
          const total = this.activeCards().reduce((sum, card) => {
            const option = card.querySelector('[data-disc-count]:checked');
            return sum + Number(option?.dataset.price || 0);
          }, 0);
          if (this.totalOutput) this.totalOutput.textContent = this.formatMoney(total);
        }

        formatMoney(cents) {
          try {
            return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: this.dataset.currency || 'USD' }).format(cents / 100);
          } catch (error) {
            return `${(cents / 100).toFixed(2)} ${this.dataset.currency || 'USD'}`;
          }
        }

        revealInvalidField(target) {
          target.closest('[data-necklace]')?.querySelector(':scope > details')?.setAttribute('open', '');
          target.closest('[data-disc]')?.querySelector(':scope > details')?.setAttribute('open', '');
        }

        property(formData, name, value) {
          if (value !== '') formData.append(`properties[${name}]`, value);
        }

        buildItem(card, totalCount) {
          const option = card.querySelector('[data-disc-count]:checked');
          const discCount = Number.parseInt(option?.value || '1', 10);
          const index = Number.parseInt(card.dataset.necklaceIndex || '1', 10);
          const formData = new FormData();
          formData.append('id', option?.dataset.variantId || '');
          formData.append('quantity', '1');
          this.property(
            formData,
            '_customization_id',
            card.dataset.customizationId || `pet-${Date.now()}-${index}`
          );
          this.property(formData, 'Necklace', `${index} of ${totalCount}`);
          this.property(formData, 'Disc count', String(discCount));
          const lengthSelect = card.querySelector('[data-chain-length]');
          const isCustom = lengthSelect?.value === 'custom';
          const inches = isCustom ? Number(card.querySelector('[data-custom-length]')?.value) : null;
          const cm = isCustom ? Math.round(inches * 2.54 * 100) / 100 : Number(lengthSelect?.value || '40');
          if (!Number.isFinite(cm) || cm <= 0 || (isCustom && inches < 21.7)) throw new Error('Invalid chain length');
          const standardInches = { 35: '13.8', 40: '15.7', 45: '17.7', 50: '19.7', 55: '21.7' };
          this.property(formData, 'Chain length', `${isCustom ? inches : standardInches[cm]} inches${isCustom ? ' (Custom)' : ''}`);
          this.property(formData, '_chain_length_cm', String(cm));
          this.property(formData, '_extender_length_cm', '5');
          if (this.dataset.deliveryPropertyName && this.dataset.deliveryPropertyValue) {
            this.property(formData, this.dataset.deliveryPropertyName, this.dataset.deliveryPropertyValue);
          }
          Array.from(card.querySelectorAll('[data-disc]:not([hidden])')).forEach((disc) => {
            const discNumber = disc.dataset.disc;
            const photo = disc.querySelector('[data-photo-input]')?.files?.[0];
            const color = disc.querySelector('[data-color-input]:checked')?.value || 'Gold';
            const name = disc.querySelector('[data-name-input]')?.value?.trim() || '';
            const back = disc.querySelector('[data-back-text]')?.value?.trim() || '';
            const font = disc.querySelector('[data-font-input]')?.value || 'F1';
            if (photo) formData.append(`properties[Disc ${discNumber} photo]`, photo, photo.name);
            this.property(formData, `Disc ${discNumber} color`, color);
            this.property(formData, `Disc ${discNumber} name`, name);
            this.property(formData, `Disc ${discNumber} back engraving`, back);
            if (name || back) this.property(formData, `Disc ${discNumber} font`, font);
            if (discNumber === '1') this.property(formData, 'Chain color', color);
          });
          return formData;
        }

        async addCard(card, totalCount) {
          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];
          config.body = this.buildItem(card, totalCount);
          const response = await fetch(this.dataset.addUrl, config);
          const result = await response.json().catch(() => ({}));
          if (!response.ok || result.status) throw new Error(result.description || result.message || 'Cart error');
          card.dataset.added = 'true';
          this.addedIndexes.add(card.dataset.necklaceIndex);
          this.updateCard(card);
        }

        async submitPersonalizations(event) {
          event.preventDefault();
          event.stopImmediatePropagation();
          if (this.busy) return;
          this.syncNecklaces();
          if (!this.form?.checkValidity()) {
            this.form?.reportValidity();
            return;
          }
          const cards = this.activeCards();
          const pending = cards.filter((card) => card.dataset.added !== 'true');
          if (!pending.length) {
            window.location.assign(this.dataset.cartUrl);
            return;
          }
          this.busy = true;
          this.errorOutput.hidden = true;
          this.countInput.disabled = true;
          if (this.submitButton) this.submitButton.disabled = true;
          if (this.submitLabel) this.submitLabel.textContent = this.dataset.addingLabel;
          const failures = [];
          for (const card of pending) {
            try {
              await this.addCard(card, cards.length);
            } catch (error) {
              failures.push({
                index: card.dataset.necklaceIndex,
                message: error instanceof Error ? error.message : '',
              });
            }
          }
          this.busy = false;
          if (!failures.length) {
            window.location.assign(this.dataset.cartUrl);
            return;
          }
          const failedIndexes = failures.map((failure) => failure.index).join(', ');
          const failureDetails = [...new Set(failures.map((failure) => failure.message).filter(Boolean))];
          const summary = this.dataset.errorTemplate
            .replace('__ADDED__', String(this.addedIndexes.size))
            .replace('__FAILED__', failedIndexes);
          this.errorOutput.textContent = failureDetails.length ? `${summary} ${failureDetails.join(' ')}` : summary;
          this.errorOutput.hidden = false;
          this.countInput.disabled = this.addedIndexes.size > 0;
          if (this.submitButton) this.submitButton.disabled = false;
          if (this.submitLabel) this.submitLabel.textContent = this.dataset.retryLabel;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
